export enum CLUB_VERIFICATION_STATUS {
  PENDING = 'P',
  APPROVED = 'A',
  REJECTED = 'C',
}

export enum PAYMENT_STATUS {
  PENDING = 'A',
  SUCCESS = 'S',
  CANCELED = 'C',
}

export enum PAYMENT_METHOD {
  HOSLOG_POINTS = 'Hoslog Points',
  ONSITE = 'On site payment',
}

export interface ReservationLedger {
  clubId: string;
  reservationId: string;
  invoiceNumber: string;
  nickName: string;
  storeInfo?: string;
  storeInfoEng: string;
  storeInfoJpn: string;
  visitingDateTime: number;
  endingDateTime: number;
  reservationType: string;
  clubImage: ClubImage;
  planType: string;
  planName: string;
  createdDate: number;
  numberOfPeople: string;
  clubVerificationStatus: CLUB_VERIFICATION_STATUS;
  paymentType: string;
  paymentMethod: string;
  paymentStatus: PAYMENT_STATUS;
  totalPlanAmount: number;
  totalClubAmount: number;
  totalPlanCommissionAmount: number;
  totalAdminCommissionAmount: number;
  totalAdminAmount: number;
  clubStatus: string;
}

export interface ClubImage {
  alt: string;
  description: string;
  path: string;
}

export interface ReservationLedgerParams {
  clubStatusFilter?: string;
  search?: string;
  fromDate?: number;
  toDate?: number;
  clubId?: string;
  row?: number;
  fetch?: number;
  planTypeFilter?: string;
  sortColumn?: string;
  sortDirection?: string;
}
